import React from "react";
import "./App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { BookingProvider } from "./context/BookingContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Reviews from "./components/Reviews";
import Products from "./components/Products";
import WhyChoose from "./components/WhyChoose";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import FloatingCTA from "./components/FloatingCTA";

function App() {
  return (
    <LanguageProvider>
      <BookingProvider>
        <div className="App min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden w-full max-w-[100vw]">
          <Header />
          <main className="overflow-x-hidden">
            <Hero />
            <About />
            <Services />
            <Gallery />
            <Reviews />
            <Products />
            <WhyChoose />
            <Contact />
          </main>
          <Footer />
          <BookingModal />
          <FloatingCTA />
        </div>
      </BookingProvider>
    </LanguageProvider>
  );
}

export default App;
